export interface IKidneyAvailOnTimeReportTotals {
    Id: number,
    dCenter: string,
    txPs: number,
    notLate: number,
    late: number,
    veryLate: number,
    latePlusVeryLate: number,
    notLatePercent: number,
    latePercent: number,
    veryLatePercent: number,
    latePlusVeryLatePercent: number,
}